<div class="tabs is-fullwidth is-toggle">
  <ul>
    <li [class.is-active]="active === 0">
      <a routerLink="trusts">
        <span>Certifikatsutfärdare</span>
      </a>
    </li>
    <li [class.is-active]="active === 1">
      <a routerLink="trust-holders">
        <span>Förtroendekällor</span>
      </a>
    </li>
  </ul>
</div>

<router-outlet></router-outlet>
